import React from 'react';
import Select from 'react-select';
import SelectVirtualized from 'react-select-virtualized';

// eslint-disable-next-line no-unused-vars
const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

class EventSelect extends React.Component {
  state = {
    selectedOption: null,
  };
  
  //select_ref = React.createRef();
  
  handleChange = selectedOption => {
    const { presenter_title, entity_uuid, getSelectedPresenters,compStatus,getSelectedPk, publishData } = this.props;
    
    getSelectedPresenters && getSelectedPresenters(presenter_title, selectedOption, entity_uuid);
    if (compStatus === "addPresentation" && getSelectedPk) {
      //console.log("EventSelect getSelectedPk",selectedOption,publishData);
      //this.select_ref.current.value = [];
      getSelectedPk(selectedOption, publishData);
    }
  };

  render() {
    const { compStatus = '', publishData = [], selectedPresenter = [] } = this.props;
    let options = [
      ...publishData,
      ...selectedPresenter
    ];
    //options = options.reverse();
    
    //if (!this.props.editable) {
    //  options.forEach((item) => {
    //    item.isDisabled = true;
    //  })
    //}
    
    if (compStatus === "addPresentation") {
      //console.log("EventSelect addPresentation",options,this.props.editable);
      return (
        <React.Fragment>
        <div style={{ color: 'black' }}>
        <SelectVirtualized
          className=''
          classNamePrefix=''
          //ref={this.select_ref}
          //isDisabled={!this.props.editable}
          //isDisabled={true}
          //isOptionDisabled={true}
          closeMenuOnSelect={true}
          value={null}
          defaultValue={selectedPresenter}
          onChange={this.handleChange}
          options={options}
          isMulti={this.props.multiple==="true" ? true : false}  
        />
        </div>
        </React.Fragment>
      );
      
    }

    return (
      <React.Fragment>
      <div style={{ color: 'black' }}>
      <Select
        styles={{ menuPortal: base => ({ ...base, color: 'black', zIndex: 9999 }) }} // to make menu not be cutoff
        menuPortalTarget={document.body} // to make menu not be cutoff
        //stlyes={selectStyles}
        //className='Select-menu-outer'
        //classNamePrefix='Select'
        //ref={this.select_ref}
        isDisabled={!this.props.editable}
        closeMenuOnSelect={true}
        //value={selectedPresenter}
        defaultValue={selectedPresenter}
        onChange={this.handleChange}
        options={options}
        isMulti={this.props.multiple==="true" ? true : false}  
      />
      </div>
      </React.Fragment>
    );
  }
}
export default EventSelect;